/** The event the low-credit alert is delivered for. */
export const LOW_CREDIT_EVENT = 'billing.low_credit';

/** One delivery destination for a notifiable event. */
export interface NotificationPreference {
  id: string;
  event_type: string;
  channel: string;
  target: string;
}
